import React from "react";

import { faEye } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { get } from "lodash";

import {
  ActionButton,
  ActionButtonContainer,
} from "components/AgGrid/ActionButton";
import { BusinessRelationshipDialog } from "components/Business/BusinessForm/Relationships/Form";

import { RELATIONSHIP_SEPARATOR } from "lib/businessRelations";
import { openBusinessRelationshipHashRoute } from "lib/navigation";

import { useBoolean } from "hooks";

const MAX_RELATIONSHIPS_SHOWN = 2;

export const BusinessRelationshipRenderer = ({ node, colDef, data }) => {
  const relationshipDetails = get(data, colDef.field);

  if (node.group || !relationshipDetails?.length) {
    return null;
  }

  const hiddenCount = relationshipDetails.length - MAX_RELATIONSHIPS_SHOWN;

  return (
    <>
      {relationshipDetails
        .slice(0, MAX_RELATIONSHIPS_SHOWN)
        .map((relationshipDetail, index) => (
          <React.Fragment key={relationshipDetail.id}>
            {index > 0 && RELATIONSHIP_SEPARATOR}
            <ActionButton
              onClick={() =>
                openBusinessRelationshipHashRoute(relationshipDetail.id)
              }
              data-tour="open-relationship"
            >
              {relationshipDetail.text}
            </ActionButton>
          </React.Fragment>
        ))}
      {hiddenCount > 0 && `${RELATIONSHIP_SEPARATOR}+${hiddenCount} more`}
    </>
  );
};

export const BusinessRelationshipActionRender = ({ data, context }) => {
  const [isOpen, handleOpen, handleClose] = useBoolean(false);

  if (!data) {
    return null;
  }

  const { saveRelationship, deleteRelationship, allowDelete, readOnly } =
    context;

  const handleSubmit = values => {
    saveRelationship(values);
    handleClose();
  };

  const { relationship } = data;

  const handleDelete = () => {
    deleteRelationship(relationship.id);
    handleClose();
  };

  return (
    <>
      <ActionButtonContainer>
        <ActionButton onClick={handleOpen} data-tour="editRelation">
          <FontAwesomeIcon icon={faEye} />
          &nbsp;View/Edit
        </ActionButton>
      </ActionButtonContainer>
      {isOpen && (
        <BusinessRelationshipDialog
          isOpen={isOpen}
          initialValues={relationship}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          handleDelete={handleDelete}
          readOnly={readOnly}
          allowDelete={allowDelete}
        />
      )}
    </>
  );
};

export const HashRouteBusinessRelationshipActionRender = ({ data, colDef }) => {
  if (!data) {
    return null;
  }

  const relationshipId = get(data, colDef.field);

  const handleOpen = () => {
    openBusinessRelationshipHashRoute(relationshipId);
  };

  return (
    <>
      <ActionButtonContainer>
        <ActionButton onClick={handleOpen} data-tour="editRelation">
          <FontAwesomeIcon icon={faEye} />
          &nbsp;View/Edit
        </ActionButton>
      </ActionButtonContainer>
    </>
  );
};
